import { useEffect } from "react";
import "./verifyEmail.scss";
import { SequenceLogos } from "../../assets";
import * as loginActions from "../../redux/actions/loginActions";
import { useDispatch } from "react-redux";
import Loader from "../../library/common/Loader";
import { useSelector } from "react-redux";

const VerifyEmail = () => {
  const queryString = window.location.search.slice(
    9,
    window.location.search?.length
  );
  const payloadData = queryString;
  const dispatch = useDispatch();
  const postVerifyEmailDataStatus = useSelector(
    (state) => state.postVerifyEmailData?.status
  );
  const showLoader = useSelector(
    (state) => state?.postVerifyEmailData?.isLoading
  );

  useEffect(() => {
    if (payloadData) {
      const data = { payload: payloadData };
      dispatch(loginActions.postVerifyEmail(data));
    }
  }, [dispatch, payloadData]);

  return (
    <>
      {showLoader && <Loader />}
      {postVerifyEmailDataStatus === "SUCCESS" && (
        <div className="verifyEmail_container">
          <img
            src={SequenceLogos?.SequenceLogo}
            alt="Sequence XT Logo"
            className="verifyEmail_logo"
          />
          <img
            src={SequenceLogos?.checkEmailVerify}
            alt="Success Icon"
            className="verify_success_icon"
          />
          <h2 className="message">Email Verified Successfully</h2>
        </div>
      )}

      {postVerifyEmailDataStatus === "FAILURE" && (
        <div className="notVerifiedEmail_container">
          <img
            src={SequenceLogos?.SequenceLogo}
            alt="Sequence XT Logo"
            className="notVerifiedEmail_logo"
          />
          <img
            src={SequenceLogos?.canceEmailVerify}
            alt="Error Icon"
            className="notVerified_error_icon"
          />
          <h2 className="notVerified_message">Email Verification Failed</h2>
          <p className="notVerified_sub_message">
            Please retry the verification
          </p>
        </div>
      )}
    </>
  );
};

export default VerifyEmail;
